export default "__VITE_ASSET__ChE8DrfR__"